export enum MetricName {
    MOBILE_APP_CRASH_COUNT = 'mobile_app_crash_count',
    MOBILE_APP_CRASH_IOS_COUNT = 'mobile_app_crash_ios_count',
    MOBILE_APP_CRASH_ANDROID_COUNT = 'mobile_app_crash_android_count',
    MOBILE_APP_NORMAL_COUNT = 'mobile_app_normal_count',
    MOBILE_APP_IOS_NORMAL_COUNT = 'mobile_app_ios_normal_count',
    MOBILE_APP_ANDROID_NORMAL_COUNT = 'mobile_app_android_normal_count',
    MOBILE_APP_PERF_RESPONSE_TIME = 'mobile_app_perf_response_time',
    MOBILE_APP_PERF_IOS_RESPONSE_TIME = 'mobile_app_perf_ios_response_time',
    MOBILE_APP_PERF_ANDROID_RESPONSE_TIME = 'mobile_app_perf_android_response_time',
    MOBILE_APP_VERSION_CRASH_COUNT ='mobile_app_version_crash_count',
    MOBILE_APP_VERSION_COUNT ='mobile_app_version_count',
    MOBILE_APP_PERF_VERSION_RESPONSE_TIME='mobile_app_perf_version_response_time'
}
export enum OSType {
    OS_ALL = "all",
    OS_ANDROID = "ANDROID",
    OS_IOS = "IOS",
}

export enum Scope {
    SERVICEINSTANCE = "ServiceInstance"
}